"use client"

import { Loader2 } from "lucide-react"
import { Skeleton } from "@/components/ui/skeleton"

export const RADIO_CLASS = "border-zinc-600 data-checked:border-emerald-500 data-checked:bg-emerald-500"
export const INPUT_CLASS = "border-zinc-700 bg-zinc-950 text-zinc-100"

export function SaveButton({
  pending,
  disabled,
  onClick,
}: {
  pending: boolean
  disabled?: boolean
  onClick: () => void
}) {
  return (
    <button
      onClick={onClick}
      disabled={pending || disabled}
      className="flex items-center gap-1.5 self-start rounded-md bg-emerald-600 px-4 py-1.5 text-sm font-medium text-white transition-colors hover:bg-emerald-500 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {pending && <Loader2 className="size-3.5 animate-spin" />}
      저장
    </button>
  )
}

export function FieldRow({ label, unit, children }: { label: string; unit?: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm text-zinc-400">{label}</label>
      <div className="flex items-center gap-2">
        {children}
        {unit && <span className="text-sm text-zinc-500">{unit}</span>}
      </div>
    </div>
  )
}

export function CardSkeleton({ rows, title }: { rows: number; title: string }) {
  return (
    <div className="flex flex-col gap-4 rounded-lg border border-zinc-800 bg-zinc-900 p-4">
      <h2 className="text-base font-semibold text-zinc-100">{title}</h2>
      <div className="flex flex-col gap-3">
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} className="h-9 w-full bg-zinc-800" />
        ))}
      </div>
    </div>
  )
}
